import { CACHE_TIME } from '@/shared/constants'
import { createApi } from '@reduxjs/toolkit/query/react'
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query'
import { gql } from 'graphql-request'

export type Article = {
  id: string
  title: string
  description: string
  content: string
  urlImage: string
  slug: string
  createdAt?: string
}

export type Category = {
  id: string
  name: string
  description: string
  urlImage: string
  slug: string
  createdAt?: string
  articles: Article[]
}

type GetCategoriesResponse = {
  helpCategories: Category[]
}

export type ArticlesByGroupNameResponse = {
  helpGroups: {
    id: string
    name: string
    articles: Article[]
  }[]
}

export type SearchArticlesResponse = {
  helpArticles: Article[]
}
console.log('redeploy')
export const helpQueryApi = createApi({
  reducerPath: 'helpQueryApi',
  baseQuery: graphqlRequestBaseQuery({
    url: `${process.env.REACT_APP_STRAPI_SERVER_URL}/graphql`,
  }),
  keepUnusedDataFor: CACHE_TIME,
  endpoints: builder => ({
    getAllCategories: builder.query<GetCategoriesResponse, void>({
      query: () => ({
        document: gql`
          query getAllHelpCategories {
            helpCategories(sort: "createdAt:asc") {
              id: documentId
              name
              description
              urlImage
              slug
              createdAt
              articles(sort: "createdAt:asc") {
                id: documentId
                title
                description
                content
                urlImage
                slug
                createdAt
              }
            }
          }
        `,
      }),
    }),
    getArticlesByGroupNames: builder.query<
      ArticlesByGroupNameResponse,
      { groupNames: string[] }
    >({
      query: ({ groupNames }) => ({
        document: gql`
          query getHelpArticlesByGroupNames($groupNames: [String]!) {
            helpGroups(filters: { name: { in: $groupNames } }) {
              id: documentId
              name
              articles(sort: "createdAt:asc") {
                id: documentId
                title
                description
                content
                urlImage
                slug
                createdAt
              }
            }
          }
        `,
        variables: { groupNames },
      }),
    }),
    searchArticles: builder.query<
      SearchArticlesResponse,
      { searchTerm: string }
    >({
      query: ({ searchTerm }) => ({
        document: gql`
          query searchHelpArticles($searchTerm: String!) {
            helpArticles(
              filters: {
                or: [
                  { title: { containsi: $searchTerm } }
                  { description: { containsi: $searchTerm } }
                  { content: { containsi: $searchTerm } }
                ]
              }
            ) {
              id: documentId
              title
              description
              content
              urlImage
              slug
            }
          }
        `,
        variables: { searchTerm },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
})

export const {
  useGetAllCategoriesQuery,
  useGetArticlesByGroupNamesQuery,
  useSearchArticlesQuery,
} = helpQueryApi
